import React, {Component} from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col,
    Label,
    Collapse
} from 'reactstrap'
import PropTypes from 'prop-types'
import {Query, Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    AvForm,
    AvField,
} from 'availity-reactstrap-validation'
import moment from 'moment'

import projectClientInvoiceQuery from '../../../queries/server/project_client_invoice'
import editInvoiceLocalMutation from '../../../queries/client_side/mutations/edit_invoice'
import editInvoiceMutation from '../../../queries/server/mutations/update_project_invoice'
import Loading from "../Loading"
import ProjectInvoiceItemCreator from "../reports/ProjectInvoiceItemCreator";
import LoadingButton from "../LoadingButton";
import {toast} from "react-toastify";

import AUSelectGenerator from '../../components/auto_updaters/ValidSelect'

const AUSelectSuppliers = AUSelectGenerator('suppliers', 'client_id name', 'client_id', ['name'])

export default class ProjectSupplierInvoiceModal extends Component {

    constructor(props) {
        super(props)
        this.file = null
    }

    state = {
        addInvoiceItem: false
    }

    render() {

        const {
            isOpen,
            toggle,
            onSave,
            invoiceID
        } = this.props

        const {
            addInvoiceItem,
            file
        } = this.state

        console.log('props', this.props)

        if (!isOpen && !invoiceID) return null

        return (
            <Query query={projectClientInvoiceQuery} variables={{id: invoiceID}}>
                {({data, loading}) => {

                    if (loading) return <Loading/>

                    const {id, invoice_number, created_at, issued_at, paid_at, breakdown, project, auto_generated, client} = data.project_client_invoice

                    const createdAt = moment(created_at).format('YYYY-MM-DD')
                    const issuedAt = (issued_at) ? moment(issued_at).format('YYYY-MM-DD') : null
                    const paidAt = (paid_at) ? moment(paid_at).format('YYYY-MM-DD') : null

                    return (

                        <Mutation mutation={editInvoiceMutation}>
                            {(editInvoiceMutationFunc, {loading}) => (

                                <Modal isOpen={isOpen} toggle={toggle} size="xl">
                                    <AvForm
                                        onInvalidSubmit={() => {
                                            console.log('invalid')
                                        }}
                                        onValidSubmit={() => {

                                            const {file} = this

                                            editInvoiceMutationFunc({
                                                variables: {
                                                    project_id: project.project_id,
                                                    data: {
                                                        id,
                                                        client_id: client.client_id,
                                                        created_at: createdAt,
                                                        issued_at: issuedAt,
                                                        paid_at: paidAt,
                                                        file,
                                                        auto_generate: auto_generated,
                                                        breakdown,
                                                        project_id: project.project_id,
                                                    }
                                                }
                                            })
                                                .then(({data}) => {
                                                    if (onSave) onSave(data.updateProjectClientInvoiceProjectReturn)
                                                    toast.success('Supplier Quote/Invoice Updated', {autoClose: 2000})
                                                })
                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                        }}>
                                        <ModalHeader>{invoice_number}</ModalHeader>
                                        <Mutation mutation={editInvoiceLocalMutation}>
                                            {(editInvoiceLocalMutationFunc) => (
                                                <ModalBody>

                                                    <Row form>
                                                        <Col>
                                                            <AUSelectSuppliers
                                                                required
                                                                errorMessage="Required"
                                                                label="Supplier*"
                                                                name="client_id"
                                                                bsSize="sm"
                                                                value={client.client_id}
                                                                onChange={(client_id) => {
                                                                    editInvoiceLocalMutationFunc({
                                                                        variables: {
                                                                            data: {
                                                                                ...data.project_client_invoice,
                                                                                client: {client_id}
                                                                            }
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row form>
                                                        <Col sm="4">
                                                            <AvField
                                                                required
                                                                errorMessage="Required"
                                                                label="Quote/Invoice Date*"
                                                                type="date"
                                                                name="invoice_date"
                                                                id="invoice_date"
                                                                size="sm"
                                                                value={createdAt}
                                                                onChange={evt => {
                                                                    editInvoiceLocalMutationFunc({
                                                                        variables: {
                                                                            data: {
                                                                                ...data.project_client_invoice,
                                                                                created_at: evt.target.value
                                                                            }
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        </Col>

                                                        <Col sm="4">
                                                            <AvField
                                                                label="Issued Date"
                                                                type="date"
                                                                name="issued_date"
                                                                id="issued_date"
                                                                size="sm"
                                                                value={issuedAt}
                                                                onChange={evt => {
                                                                    editInvoiceLocalMutationFunc({
                                                                        variables: {
                                                                            data: {
                                                                                ...data.project_client_invoice,
                                                                                issued_at: evt.target.value
                                                                            }
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        </Col>

                                                        <Col sm="4">
                                                            <AvField
                                                                label="Paid Date"
                                                                type="date"
                                                                name="paid_date"
                                                                id="paid_date"
                                                                size="sm"
                                                                value={paidAt}
                                                                onChange={evt => {
                                                                    editInvoiceLocalMutationFunc({
                                                                        variables: {
                                                                            data: {
                                                                                ...data.project_client_invoice,
                                                                                paid_at: evt.target.value
                                                                            }
                                                                        }
                                                                    })
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row form>

                                                        <Col>
                                                            <AvField
                                                                bsSize="sm"
                                                                type="file"
                                                                label="Upload File"
                                                                name="invoice_file"
                                                                onChange={(evt) => {
                                                                    console.log('file selected', evt.target.files[0])
                                                                    //this.setState({file: evt.target.files[0]})
                                                                    this.file = evt.target.files[0]
                                                                }}
                                                            />
                                                        </Col>

                                                    </Row>

                                                    <Label className="mt-3">Budget Items</Label>

                                                    {
                                                        breakdown.map((bd, index) => {
                                                            return (
                                                                <Row key={index} form>
                                                                    <Col sm="8">
                                                                        <AvField
                                                                            required
                                                                            size="sm"
                                                                            name={`description${index}`}
                                                                            type="text"
                                                                            value={bd.description}
                                                                            onChange={evt => {

                                                                                //const recordIndex = breakdown.findIndex(({id}) => id === bd.id)

                                                                                const newBreakdown = [
                                                                                    ...breakdown.slice(0, index),
                                                                                    {
                                                                                        ...bd,
                                                                                        description: evt.target.value
                                                                                    },
                                                                                    ...breakdown.slice(index + 1)
                                                                                ]

                                                                                editInvoiceLocalMutationFunc({
                                                                                    variables: {
                                                                                        data: {
                                                                                            ...data.project_client_invoice,
                                                                                            breakdown: newBreakdown
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                    <Col sm="3">
                                                                        <AvField
                                                                            size="sm"
                                                                            name={`amount${index}`}
                                                                            type="number"
                                                                            value={bd.amount}
                                                                            onChange={evt => {

                                                                                //const recordIndex = breakdown.findIndex(({id}) => id === bd.id)

                                                                                const newBreakdown = [
                                                                                    ...breakdown.slice(0, index),
                                                                                    {...bd, amount: evt.target.value},
                                                                                    ...breakdown.slice(index + 1)
                                                                                ]

                                                                                editInvoiceLocalMutationFunc({
                                                                                    variables: {
                                                                                        data: {
                                                                                            ...data.project_client_invoice,
                                                                                            breakdown: newBreakdown
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                    <Col sm="1">
                                                                        <LoadingButton
                                                                            size="sm"
                                                                            className="square-btn pull-right"
                                                                            icon="trash-alt"
                                                                            loading={false}
                                                                            color="danger"
                                                                            onClick={() => {
                                                                                const newBreakdown = [
                                                                                    ...breakdown.slice(0, index),
                                                                                    ...breakdown.slice(index + 1)
                                                                                ]

                                                                                editInvoiceLocalMutationFunc({
                                                                                    variables: {
                                                                                        data: {
                                                                                            ...data.project_client_invoice,
                                                                                            breakdown: newBreakdown
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }}
                                                                        />
                                                                    </Col>

                                                                </Row>
                                                            )
                                                        })
                                                    }

                                                    <div>
                                                        <Button
                                                            size="sm"
                                                            color={addInvoiceItem ? 'warning' : 'success'}
                                                            onClick={() => this.setState({addInvoiceItem: !addInvoiceItem})}
                                                        >
                                                            <FontAwesomeIcon color="#fff"
                                                                             icon={addInvoiceItem ? 'minus' : 'plus'}/>{' '}{addInvoiceItem ? 'Cancel' : 'Add Budget Item'}
                                                        </Button>
                                                    </div>

                                                    <Collapse isOpen={addInvoiceItem}>
                                                        <div
                                                            className={`d-flex flex-column pt-3 mt-3 card card-body bg-light`}>
                                                            <ProjectInvoiceItemCreator
                                                                budgets={project.project_activity_budgets}
                                                                onAdd={(invoiceItem) => {

                                                                    const newBreakdown = [
                                                                        ...breakdown,
                                                                        {...invoiceItem}
                                                                    ]

                                                                    console.log(invoiceItem, newBreakdown)

                                                                    editInvoiceLocalMutationFunc({
                                                                        variables: {
                                                                            data: {
                                                                                ...data.project_client_invoice,
                                                                                breakdown: newBreakdown
                                                                            }
                                                                        }
                                                                    })

                                                                    this.setState({addInvoiceItem: false})
                                                                }}
                                                            />
                                                        </div>
                                                    </Collapse>


                                                </ModalBody>
                                            )}

                                        </Mutation>
                                        <ModalFooter>

                                            <Button
                                                size="sm"
                                                color="success"
                                                disabled={loading}
                                            >
                                                <FontAwesomeIcon
                                                    color="#fff"
                                                    icon={loading ? 'spinner' : 'save'}
                                                    spin={loading}
                                                />
                                                {' '}
                                                {loading ? 'Saving...' : 'Save'}
                                            </Button>
                                        </ModalFooter>
                                    </AvForm>
                                </Modal>

                            )}

                        </Mutation>
                    )

                }}

            </Query>
        )

    }

}

ProjectSupplierInvoiceModal.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    invoiceID: PropTypes.number.isRequired
}